import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HOST,CONSULTAR_NOVEDAD_PERIODO } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class NovedadesService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

consultarNovedadReportada(idPeriodo, idFuente):Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CONSULTAR_NOVEDAD_PERIODO+ idPeriodo+ "/"+ idFuente;
  return this.http.get<any>(direccion, {'headers': header});
}

}
